import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PortalContext, IApiEndpointService} from '@de.fiduciagad.kundenportal/ui-context';
import {Observable} from 'rxjs';
import {shareReplay} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RestCallerService {
  private readonly portalcontext = inject(PortalContext);

  constructor(private readonly http: HttpClient) {
  }

  public executeGET<T>(restUrl: string, serviceName: string, paramsIn?: {
    [param: string]: string | string[]
  }): Observable<T> {
    const options = {params: paramsIn};
    const url = this.getUrl(restUrl, serviceName);
    return this.http.get<T>(this.checkUrl(url), options).pipe(shareReplay());
  }

  public executePUT<T>(restUrl: string, serviceName: string, body: any): Observable<T> {
    const url = this.getUrl(restUrl, serviceName);
    return this.http.put<T>(this.checkUrl(url), body);
  }

  public executePOST<T>(restUrl: string, serviceName: string, body: any): Observable<T> {
    const url = this.getUrl(restUrl, serviceName);
    return this.http.post<T>(this.checkUrl(url), body);
  }

  public executeDELETE<T>(restUrl: string, serviceName: string): Observable<T> {
    const url = this.getUrl(restUrl, serviceName);
    return this.http.delete<T>(this.checkUrl(url));
  }

  private getUrl(uri: string, serviceName: string) {
    return (this.portalcontext.getApiEndpointService() as IApiEndpointService).getServiceUrl(serviceName,
      '/' + uri.toString());
  }

  private checkUrl(url: string): string {
    if (url?.endsWith('/')) {
      url = url.slice(0, url.length - 1);
    }
    return url;
  }
}
